module.exports = __webpack_public_path__ + "media/12.067ed4a2.mp3";